import { Link } from "@tanstack/react-router";
import { SITE } from "@/lib/site";
import { CATEGORIES } from "@/lib/blog";

const ADDRESS_LINE = "SBS Quadra 2, Bloco E — Asa Sul, Brasília — DF, Brasil";
const MAPS_LINK = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(ADDRESS_LINE);
const MAPS_EMBED = "https://www.google.com/maps?q=" + encodeURIComponent(ADDRESS_LINE) + "&output=embed";

export function Footer() {
  const highlightCategories = CATEGORIES.slice(0, 6);

  return (
    <footer className="mt-24 border-t border-border bg-foreground text-background">
      <div className="container-svg grid gap-10 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span aria-hidden className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary font-bold text-primary-foreground text-sm leading-none">EB</span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-lg font-bold">Empresa Brasil Online</span>
              <span className="text-[10px] uppercase tracking-[0.24em] text-background/60 mt-1">Gestão Marketing & Vendas Negócios</span>
            </span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-background/70">
            {SITE.description}
          </p>
          <div className="mt-6">
            <Link to="/blog" className="inline-flex items-center gap-2 rounded-lg bg-background px-5 py-2.5 text-sm font-semibold text-foreground hover:bg-background/90 transition">Ler os artigos</Link>
          </div>
        </div>
        <div className="md:col-span-3">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-background/50">Categorias</h3>
          <ul className="mt-4 space-y-2 text-sm text-background/75">
            <li><Link to="/blog" className="hover:text-background transition-colors">Todos os artigos</Link></li>
            {highlightCategories.map((c) => (
              <li key={c}>
                <Link to="/blog" hash={`cat=${encodeURIComponent(c)}`} className="hover:text-background transition-colors">{c}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-background/50">A plataforma</h3>
          <ul className="mt-4 space-y-2 text-sm text-background/75">
            <li><Link to="/sobre" className="hover:text-background transition-colors">Sobre</Link></li>
            <li><Link to="/equipe" className="hover:text-background transition-colors">Redação</Link></li>
            <li><Link to="/contato" className="hover:text-background transition-colors">Contato</Link></li>
            <li><a href={`mailto:${SITE.email}`} className="hover:text-background transition-colors">{SITE.email}</a></li>
            <li><Link to="/admin" className="hover:text-background transition-colors">Área administrativa</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background/10">
        <div className="container-svg grid gap-8 py-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-background/50">Onde estamos</h3>
            <p className="mt-4 font-display text-2xl font-semibold leading-tight">Centro — Brasília, DF</p>
            <p className="mt-3 text-sm text-background/70">{ADDRESS_LINE}</p>
            <a
              href={MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-lg border border-background/25 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-background hover:bg-background hover:text-foreground transition"
            >
              Abrir no Google Maps →
            </a>
          </div>
          <div className="md:col-span-7">
            <div className="overflow-hidden rounded-xl border border-background/10 shadow-[0_10px_40px_-20px_rgba(0,0,0,0.6)]">
              <iframe
                title="Mapa — Centro, Brasília, DF"
                src={MAPS_EMBED}
                width="100%"
                height="280"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="block w-full"
                style={{ border: 0 }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background/10">
        <div className="container-svg flex flex-col items-start justify-between gap-2 py-6 text-xs text-background/55 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} {SITE.name}. Todos os direitos reservados.</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/termos-de-uso" className="hover:text-background transition-colors">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="hover:text-background transition-colors">Política de Privacidade</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
